<div class="root-container" tabindex="1">
  <img class="avatar" [src]="currentUser().image ?? 'assets/images/defaults/default_user.png'" alt="profile photo" />
  <div class="current-user"> Logged in as: <strong> {{ currentUser().first_name | titlecase }} {{
      currentUser().last_name | titlecase }} </strong> </div>
  <div class="user-menu">
    <a [routerLink]="[auth.getRoleIndex(), 'profile']"> <i class="bi bi-person"></i> My Profile </a>
    <a [routerLink]="[`${auth.getRoleIndex()}`, 'faq']"> <i class="bi bi-question-circle"></i> FAQ & Support</a>
    @if (isWithLogs()) {
      <a [routerLink]="[auth.getRoleIndex(), 'logs']"> <i class="bi bi-clock"></i> Activity Logs </a>
    }
    <a (click)="confirmLogout()"> <i class="bi bi-box-arrow-right"></i> Logout </a>
  </div>
</div>